import { Fragment } from "react";
import { Grid, Container } from "@material-ui/core";
import BlockIcon from "@material-ui/icons/Block";

import { Margin } from "../styles/GerenciamentoContrato";

import TableDefault from "../../../../components/grid/TableDefault";
import MaskService from "../../../../utils/mask/maskService";
import { formatDate } from "../../../../utils/formatDate";
import useGerenciamentoContratoListagemController from "../controllers/GerenciamentoContratoListagemController";

const TabAbatimento = ({ content, setContent, setCrRows }) => {
  const { abatimentoEstorno } = useGerenciamentoContratoListagemController();

  const estornoAbatimento = async (id) => {
    let estorno = await abatimentoEstorno(id, content[0].idcr, setCrRows);

    if (estorno) {
      let copy = [...content];
      let index = copy.findIndex((e) => e.id === id);
      copy[index] = {
        ...copy[index],
        rowError: true,
      };
      setContent((e) => ({ ...e, abatimentos: copy }));
    }
  };

  const columns = [
    {
      id: "id",
      label: "ID",
      align: "left",
    },
    {
      id: "motivo",
      label: "Motivo",
      align: "left",
    },
    {
      id: "saldoanterior",
      label: "Saldo Anterior",
      align: "left",
      format: (value) =>
        `R$ ${
          value?.saldoanterior
            ? MaskService.toMask(
                "decimal",
                parseFloat(value?.saldoanterior).toFixed(2)
              )
            : "0,00"
        } `,
    },
    {
      id: "saldoatual",
      label: "Saldo Atual",
      align: "left",
      format: (value) =>
        `R$ ${
          value?.saldoatual
            ? MaskService.toMask(
                "decimal",
                parseFloat(value?.saldoatual).toFixed(2)
              )
            : "0,00"
        } `,
    },
    {
      id: "vlrabatimento",
      label: "Valor",
      align: "left",
      format: (value) =>
        `R$ ${
          value?.vlrabatimento
            ? MaskService.toMask(
                "decimal",
                parseFloat(value?.vlrabatimento).toFixed(2)
              )
            : "00,00"
        } `,
    },
    {
      id: "data",
      label: "Data",
      align: "left",
      format: (value) =>
        formatDate({
          date: value?.data,
          separator: "/",
          format: "dd/mm/yyyy",
        }),
    },
    {
      label: "Estorno",
      name: "cancelar",
      format: (value) =>
        value.estorno === "N" &&
        value.vlrabatimento < 0 &&
        !value.rowError && (
          <BlockIcon
            style={{ cursor: "pointer" }}
            color="error"
            onClick={() => estornoAbatimento(value.id)}
          />
        ),
    },
  ];

  return (
    <>
      <Margin top={25}>
        <Container maxWidth="lg">
          <Margin top={25}>
            <Grid item xs={12}>
              <TableDefault
                tableTitle=""
                columns={columns}
                values={content.map((row) => {
                  return {
                    ...row,
                    rowError:
                      row.rowError ||
                      row.vlrabatimento > 0 ||
                      row.estorno === "S",
                  };
                })}
                minHeight="350px"
                orderSort="desc"
                selectedByRow={true}
                rowsPerPage={content?.length}
                disabledDefaultPagination
                disabledEmptySpace
              />
            </Grid>
          </Margin>
        </Container>
      </Margin>
    </>
  );
};

export default TabAbatimento;
